module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAMAAADzN3VRAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABXUExURUdwTAuC+guC+g969RB89g1/+A189RF89gmE+gyB+QBw3g6A+Ah29A1/+A5/9wmE+wuC+QeG+gB19Q5+9wqD+gaH/AiE+wmE+gSJ/QeG+wyB+BJ79RZ3828nlPEAAAATdFJOUwCuYiNUQzKC06gF3RC9yGzsoQxJy3INAAAAu0lEQVQoz32R2Q6DIBREL8iq4E5Z//87q9ZSDdjDE3NCSGYASpQYKdRoOuccq4jBb8KhIqfCHZj5Fre4N86Yw5BfzAa0ZebEccAYA5mQsP7OBNZakNZvx9qXzXh9mhIB67qCXEv+mRACyFDybHpYlgXkUoJAaw28GwvDczEN4ejqvzs0lKq9IS7ihy5XH6M860OHyYWyGFMeoosx/wJzvNwUv47NU0qkOr5Kj4rsqqmZtt8Mqz5qOb49eQNyvhsNzPtLBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/horn.png
// module id = u4EC
// module chunks = 0